import React, { useContext } from "react";

export type Customer = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  isWholeSale: boolean;
  hasSubscriptions: boolean;
  ordersCount: number;
};

const CustomerContext = React.createContext<Customer | null>(null);

export const CustomerProvider = ({
  children,
  customer,
}: React.PropsWithChildren<{ customer: Customer | null }>) => {
  return (
    <CustomerContext.Provider value={customer}>
      {children}
    </CustomerContext.Provider>
  );
};

export function useCustomer() {
  return useContext(CustomerContext);
}
